import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import SubverticalPage from "./pages/SubverticalPage";
import NewsletterConfirmPage from "./pages/NewsletterConfirmPage";
import LegalPage from "./pages/LegalPage";
import FounderBrainPage from "./pages/FounderBrainPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import BlogPostPage from "./pages/BlogPostPage";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/founder");
  return (
    <>
      <ScrollManager />
      {!bare && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/trades/:trade" element={<SubverticalPage />} />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/newsletter/confirm" element={<NewsletterConfirmPage />} />
        <Route path="/legal/privacy" element={<LegalPage slug="privacy" />} />
        <Route path="/legal/terms" element={<LegalPage slug="terms" />} />
        <Route path="/legal/aup" element={<LegalPage slug="aup" />} />
        <Route path="/founder/brain" element={<FounderBrainPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
